export const cachetime = 1000 * 60 * 10;